 <div class="container py-5">
    <div class="section-title">
        <h2>Über Tommys</h2>
        <div class="bar"></div>
        <p>Dein schneller Weg zum Führerschein – persönlich, modern und ohne lange Wartezeiten. Willkommen bei Tommys Fahrschule in Gießen!</p>
    </div>

    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="about-content">
                <h3>Deine Ausbildung, dein Tempo – wir machen’s möglich!</h3>
                <div class="bar"></div>
                <p>Mit unserem jungen und engagierten Team bieten wir dir eine flexible, praxisnahe und stressfreie Ausbildung. Theorie in nur 7 Tagen? Kein Problem!</p>
                <p>Unsere modernen Fahrzeuge, top Fahrlehrer und individuelle Betreuung sorgen dafür, dass du optimal vorbereitet in die Prüfung gehst – und sicher auf die Straße.</p>
                <div class="about-btn">
                    <a routerLink="/kontakt" class="default-btn">Jetzt starten <span></span></a>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="about-image">
                <img src="assets/img/about.png" alt="image">
            </div>
        </div>
    </div>
</div>
